import React, { Component, Fragment } from 'react';
import styles from './index.less';
import loadImg from 'images/loadm@2x.png';
class Loading extends Component {
  render() {
    const { loading, children } = this.props;

    return (
      <Fragment>
        {loading ? (
          <div className={styles.loading}>
            <div className={styles.load}>
              <img src={require('images/loadm@2x.png')} alt="" />
              <p>loading</p>
            </div>
          </div>
        ) : (
          children
        )}
      </Fragment>
    );
  }
}

export default Loading;
